import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import settings from '../public/settings.json';
import store from './store'
import axios from 'axios'
import 'regenerator-runtime/runtime'



import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'


Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.prototype.$log = console.log.bind(console)



const baseAPI = axios.create({
  baseURL: settings.apiURL
});

const UNAUTHORIZED = 401;


Vue.mixin({
  methods: {
    GetBaseUrl() {
      return settings.apiURL;
    },
    UserAuth() {
      return this.$API
        .get(this.$UserAuth, {
          withCredentials: true
        })
        .then(response => {
          if (response.status == 202) {
            return true;
          } else
            return false;
        });
    },
    GoToLogin() {
      let path = this.$router.currentRoute.path;
      if (path.toLowerCase() != "/login") {

        this.$router.push({
          path: '/Login',
          query: {
            targetUrl: this.$router.currentRoute.fullPath,
          }
        })

      }
    },
    GoToSignUp() {
      let path = this.$router.currentRoute.path;
      if (path.toLowerCase() != "/index") {
        this.$router.push("/Index");
      }
    },
    GoToHome() {
      this.$router.push("/tutor/login");
    },
    SignOut: function () {
      return this.$API
        .get(this.$SignOut, {
          withCredentials: true
        })
        .then(response => {
          if (response.status == 200) {
            this.$router.push("/Login");
          }
        });

    },
  }

})

baseAPI.interceptors.response.use(response => response, error => {
  const {
    status
  } = error.response;
  if (status == UNAUTHORIZED) {
    router.push("/Login");
  } else {
    console.log("test");
  }
  return Promise.reject(error);
  //
})

Vue.prototype.$API = baseAPI

Vue.prototype.$EditSchedule = 'kiddo/Read/ScheduleDetails'
Vue.prototype.$DuplicateSchedule = 'kiddo/Read/ScheduleToDuplicate'
Vue.prototype.$GetListSubject = 'kiddo/Read/ScheduleSubjectList'
Vue.prototype.$GetListSubjectCopy = 'kiddo/Read/ScheduleSubjectListCopy'
Vue.prototype.$ProfileTeacher = 'kiddo/Read/TeacherProfile'
Vue.prototype.$ProfileTeacherApp = 'kiddo/Read/TeacherProfileApp'
Vue.prototype.$ProfessionalTeacher = 'kiddo/Read/TeacherProfessional'
Vue.prototype.$ListSubject = 'kiddo/Read/SubjectList'
Vue.prototype.$ListGrade = 'kiddo/Read/GradeList'
Vue.prototype.$ListTeacher = 'kiddo/Read/FindTutorTeacherList'
Vue.prototype.$FilterTeacher = 'kiddo/Read/FilterTeacher'
Vue.prototype.$ListChild = 'kiddo/Read/ListChild'
Vue.prototype.$UserType = 'kiddo/Read/StatusUserType'
Vue.prototype.$DetailParent = 'kiddo/Read/DetailParent'
Vue.prototype.$AllWaitingList = 'kiddo/Read/GetWaitingList'
Vue.prototype.$Request = 'kiddo/Read/GetRequest'
Vue.prototype.$RequestNotificationStudent = 'kiddo/Read/RequestNotificationStudent'
Vue.prototype.$CheckStatusJob = 'kiddo/Read/CheckingStatusJob'
Vue.prototype.$CheckTutorJob = 'kiddo/Read/CheckingTutorJob'
Vue.prototype.$Faq = 'kiddo/Read/GetFaq'
Vue.prototype.$AnswerFaqById = 'kiddo/Read/GetFaqById'
Vue.prototype.$InsertFindTutors = 'kiddo/Insert/SearchTutor'
Vue.prototype.$SignOut = 'kiddo/Insert/SignOut'
Vue.prototype.$UserAuth = 'kiddo/Insert/IsAuthenticated'
Vue.prototype.$SignUp = 'kiddo/Insert/Register'
Vue.prototype.$SignUpTutor = 'kiddo/Insert/RegisterTeachers'
Vue.prototype.$StudentProfileById = 'kiddo/Read/GetStudentProfileByUserId'
Vue.prototype.$News = 'kiddo/Read/GetArticleSome'
Vue.prototype.$Reminder = 'kiddo/Read/GenerateEWallet'
Vue.prototype.$ListStudents = 'kiddo/Read/ListStudentPayment'
Vue.prototype.$ListQuestionFeedback = 'kiddo/Read/ListFeedbackQuestion'
Vue.prototype.$GetRates = 'kiddo/read/GetRate'


Vue.prototype.$StudentSubjectList = 'kiddo/Read/AllStudentSubjectListByUserId'
Vue.prototype.$AllStudentName = 'kiddo/Read/AllStudentName'
Vue.prototype.$FindtutorFullDetails = 'kiddo/Read/CheckFullFindTutor'
Vue.prototype.$NotificationTeacher = 'kiddo/Read/NotificationTeacher'
Vue.prototype.$NotificationStudent = 'kiddo/Read/NotificationStudent'
Vue.prototype.$Languages = 'kiddo/Read/GetLanguage'
Vue.prototype.$Sessions = 'kiddo/Read/GetSession'
Vue.prototype.$Times = 'kiddo/Read/GetTime'
Vue.prototype.$Durations = 'kiddo/Read/GetDuration'
Vue.prototype.$DurationGroups = 'kiddo/Read/GetDurationGroup'
Vue.prototype.$ConfirmationClass = 'kiddo/Read/ConfirmationClass'
Vue.prototype.$ConfirmationClassStatus = 'kiddo/Read/CheckConfirmation'
Vue.prototype.$CheckStatusByFindTutorID = 'kiddo/Read/CheckStatusByFindTutorID'
Vue.prototype.$NotificationClassLanguage = 'kiddo/Read/NotificationClassLanguage'
Vue.prototype.$NotificationClassSession = 'kiddo/Read/NotificationClassSession'
Vue.prototype.$NotificationStudentResponse = 'kiddo/Read/NotificationStudentResponse'
Vue.prototype.$NotificationClassTime = 'kiddo/Read/NotificationClassTime'
Vue.prototype.$GetAcceptJob = 'kiddo/Read/GetAcceptJob'
Vue.prototype.$NotifyStudentJobAccepted = 'kiddo/Read/NotifyStudentJobAccepted'
Vue.prototype.$NotifyStudentTutorResponse = 'kiddo/Read/NotifyStudentTutorResponse'
Vue.prototype.$NotifyTeacherSetSchedule = 'kiddo/Read/NotifyTeacherSetSchedule'
Vue.prototype.$NotificationConfirmResponseStudent = 'kiddo/Read/NotificationConfirmResponseStudent'
Vue.prototype.$NotificationConfirmResponseToTeacher = 'kiddo/Read/NotificationConfirmResponseToTeacher'
Vue.prototype.$TeacherClassGrade = 'kiddo/Read/TeacherClassGrade'
Vue.prototype.$GetFindTutor = 'kiddo/Read/FindTutor'
Vue.prototype.$ListRequest = 'kiddo/Read/GetListRequest'
Vue.prototype.$FindTutorStudent = 'kiddo/Read/FindTutorStudent'
Vue.prototype.$NotificationTeacherSchedule = 'kiddo/read/NotificationTeacherSchedule'
Vue.prototype.$AllFindTutor = 'kiddo/Read/GetFindTutorAllId'
Vue.prototype.$TeacherByFindTutor = 'kiddo/Read/GetTeacherByFindTutorId'
Vue.prototype.$OfferDirectFindTutor = 'kiddo/Insert/OfferDirectToTeacher'
Vue.prototype.$WaitingListStudent = 'kiddo/Read/WaitingListStudent'
Vue.prototype.$StudentGrouping = 'kiddo/Insert/StudentGrouping'


//Quiz
Vue.prototype.$CheckStudentSubGraStat = 'kiddo/Read/CheckStudentSubGraStat'
Vue.prototype.$StudentUpdateStatus = 'kiddo/Insert/StudentUpdateStatus'
Vue.prototype.$QuizSubjectList = 'kiddo/Read/QuizSubjectAll'
Vue.prototype.$QuizTeacherDetails = 'kiddo/Read/TeacherQuizGroupBySubject'
Vue.prototype.$QuizTeacherStatistics = 'kiddo/Read/TeacherQuizCountStudentAnswer'
Vue.prototype.$QuizTeacherPublishByQuiz = 'kiddo/Read/QuizTeacherPublishByQuiz'
Vue.prototype.$QuizGradeList = 'kiddo/Read/QuizGradeAll'
Vue.prototype.$QuizSummary = 'kiddo/Read/QuizSummary'
Vue.prototype.$QuizPreview = 'kiddo/Read/QuizPreview'
Vue.prototype.$QuizStartNumber = 'kiddo/Read/QuizNo'
Vue.prototype.$CreateQuizTitle = 'kiddo/Insert/TeacherCreateQuiz'
Vue.prototype.$CreateQuizQuestion = 'kiddo/Insert/InsertTeacherQuestion'
Vue.prototype.$QuizTeacherNewQuestion = 'kiddo/Insert/QuizTeacherNewQuestion'
Vue.prototype.$EditQuizQuestion = 'kiddo/Insert/EditTeacherQuestion'
Vue.prototype.$PublishQuiz = 'kiddo/Insert/QuizPublish'
Vue.prototype.$UploadPhoto = 'kiddo/FileTransfer/UploadQuizQuestion'
Vue.prototype.$GetUsersPayment = 'kiddo/Read/GetUserDatas'
Vue.prototype.$GetCheckPassword = 'kiddo/Read/checkPaymentPassword'
Vue.prototype.$EwalletDirectPayment = 'kiddo/Insert/EwalletDirectPayment'

Vue.prototype.$StudentStartQuiz = 'kiddo/Insert/QuizStartStudent'
Vue.prototype.$QuizQuestion = 'kiddo/Read/QuizStudentCurrentQues'
Vue.prototype.$StudentSubmitAnswer = 'kiddo/Insert/StudentSubmitAnswer'
Vue.prototype.$ListQuestion = 'kiddo/Read/ListQuestionByQuizId'
Vue.prototype.$StudentList = 'kiddo/Read/GetStudentListByParentId'
Vue.prototype.$ListTeacherQuizBySubjectId = 'kiddo/Read/ListTeacherQuizBySubjectId'
Vue.prototype.$QuizStudentDetail = 'kiddo/Read/StudentQuizGroupBySubjectId'
Vue.prototype.$ListStudentQuizBySubjectId = 'kiddo/Read/StudentQuizList'
Vue.prototype.$GetStudentFinalScore = 'kiddo/Read/GetStudentFinalScore'
Vue.prototype.$QuizStudentRecordBySubjectId = 'kiddo/Read/QuizStudentRecordBySubjectId'
Vue.prototype.$QuizStudentHistoryByQuiz = 'kiddo/Read/QuizStudentHistoryByQuiz'
Vue.prototype.$QuizStudentLeaderBoard = 'kiddo/Read/QuizStudentLeaderBoard'
Vue.prototype.$QuizTeacherLeaderBoard = 'kiddo/Read/QuizTeacherLeaderBoards'
Vue.prototype.$QuizStudentHistoryDetailByQuiz = 'kiddo/Read/QuizStudentHistoryDetailByQuiz'
Vue.prototype.$StudentProfile = 'kiddo/Read/GetStudentProfile'
Vue.prototype.$ParentProfile = 'kiddo/Read/ParentProfile'
Vue.prototype.$QuizStudentStatisticAverageScore = 'kiddo/Read/QuizStudentStatisticAverageScore'
Vue.prototype.$QuizTeacherStatisticTopRankStudents = 'kiddo/Read/QuizTeacherStatisticTopRankStudents'
Vue.prototype.$QuizTeacherStatisticQuizCount = 'kiddo/Read/QuizTeacherStatisticQuizCount'
Vue.prototype.$QuizTeacherStatisticTopQuizRank = 'kiddo/Read/QuizTeacherStatisticTopQuizRank'

Vue.prototype.$SubmitFeedback = 'kiddo/Insert/StudentSubmitFeedback'
//comment because of redundant api name


Vue.prototype.$GetQuestionDetail = 'kiddo/Read/GetQuestionDetail'


//FindTutor
Vue.prototype.$GetFindTutorDetail = 'kiddo/Read/GetFindTutorDetail'
Vue.prototype.$SetSchedule = 'kiddo/insert/TeacherSetSchedule'
Vue.prototype.$TeacherCreateSchedule = 'kiddo/insert/TeacherCreateSchedule'
Vue.prototype.$DeleteTeacherSubjectGrade = 'kiddo/insert/DeleteTeacherSubjectGrade'

//Teacher Profile
Vue.prototype.$TeacherProfile = 'kiddo/Read/UserProfile'
Vue.prototype.$TeacherSubjectGrade = 'kiddo/Read/TeacherSubjectGrade'
Vue.prototype.$TeacherAcademiceProfile = 'kiddo/Read/TeacherAcademiceProfile'
Vue.prototype.$TeacherWorkBackground = 'kiddo/Read/TeacherWorkBackground'
Vue.prototype.$TeacherAreasOfExpertise = 'kiddo/Read/TeacherAreasOfExpertise'
Vue.prototype.$TeacherProfessional = 'kiddo/Read/TeacherProfessional'
Vue.prototype.$TeacherLanguage = 'kiddo/Read/TeacherLanguage'

//Create or Edit Teacher Profile
Vue.prototype.$InsertUpdateProfessionalProfile = 'kiddo/Insert/TeacherProfessionalProfileCreatedEdit'
Vue.prototype.$InsertUpdateAcademiceProfile = 'kiddo/Insert/TeacherAcademicProfileCreatedEdit'
Vue.prototype.$InsertUpdateAreaofExpertises = 'kiddo/Insert/TeacherAreasOfExpertiseCreatedEdit'
Vue.prototype.$InsertUpdateWorkBackground = 'kiddo/Insert/TeacherWorkBackgroundCreatedEdit'

Vue.prototype.$InsertNewSchedule = 'kiddo/Insert/CreateScheduleByTeacher'
Vue.prototype.$UpdateSchedules = 'kiddo/insert/EditScheduleByTeacher'
Vue.prototype.$StudentFilterSubject = 'kiddo/Insert/StudentFilterSubject'
Vue.prototype.$StudentFilterSubjectGroup = 'kiddo/Insert/StudentFilterSubjectGroup'
Vue.prototype.$TeacherConfirmClass = 'kiddo/Insert/TeacherConfirmClass'
Vue.prototype.$TeacherConfirmClassGroup = 'kiddo/Insert/TeacherConfirmClassGroup'
Vue.prototype.$StudentResponse = 'kiddo/Insert/StudentResponse'
Vue.prototype.$StudentAppoint = 'kiddo/Insert/StudentAppoint'
Vue.prototype.$RegisterStudent = 'kiddo/insert/RegisterStudent'
Vue.prototype.$RegisterManualStudent = 'kiddo/insert/RegisterManualStudent'
Vue.prototype.$NewSubject = 'kiddo/insert/NewSubject'
Vue.prototype.$InsertWaitingList = 'kiddo/insert/WaitingList'
Vue.prototype.$TeacherTeachSubject = 'kiddo/insert/TeacherTeachSubject'
Vue.prototype.$TeacherAddNewSubject = 'kiddo/insert/TeacherAddNewSubject'
Vue.prototype.$RegisterNewSubjectGrade = 'kiddo/insert/RegisterNewSubjectGrade'
Vue.prototype.$InsertStudentSchedule = 'kiddo/insert/STUDENTSCHEDULE'
Vue.prototype.$InsertDirectFindTutorOneToOne = 'kiddo/insert/DirectFindTutorOneToOne'
Vue.prototype.$InsertDirectFindTutorGrouping = 'kiddo/insert/DirectFindTutorGrouping'

Vue.prototype.$InsertFaq = 'kiddo/insert/Faq'

Vue.prototype.$UpdateWaiting = 'kiddo/update/WaitingList'
Vue.prototype.$UpdateAcceptJob = 'kiddo/update/AcceptJob'

Vue.prototype.$UpdateProfessionalProfile = 'kiddo/update/ProfessionalProfile'
Vue.prototype.$UpdateAreaOfExpertise = 'kiddo/update/AreaOfExpertise'
Vue.prototype.$TeacherDeleteSubject = 'kiddo/update/UpdateTeacherSubject'

Vue.prototype.$ContactUs = 'contact/index'
Vue.prototype.$RegisterPartner = 'kiddo/insert/Partner'

Vue.prototype.$LoginTeacher = 'kiddo/insert/LoginTeachers'
Vue.prototype.$LoginStudent = 'kiddo/insert/LoginStudents'
Vue.prototype.$ForgotPassword = 'kiddo/insert/ForgotPassword'
Vue.prototype.$ValidateForgotPasswordCode = 'kiddo/insert/ValidateForgotPasswordCode'
Vue.prototype.$ChangePassword = 'kiddo/insert/ChangePassword'
Vue.prototype.$InsertReferProgram = 'kiddo/insert/ReferProgram'
Vue.prototype.$ListQuestionAll = 'kiddo/Read/ListQuestionByQuizIdArrayAnswer'
Vue.prototype.$StudentSubmitAnswerAll = 'kiddo/insert/StudentSubmitAnswerAll'



new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})
